var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider",class:{vertical: _vm.vertical}},[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }